import imgNoel from  "../img/noel.png";
import boulier from  "../img/boulier.png";
import logoBlanc from  "../img/logo-blanc.png";


export default function StartScreen(props) {
	return <div className="start_screen">
        <div className="pn_image_container">
          <div className="pn_boulier">
          	<img src={boulier}/>
          	<span>Les P'tits Simulateurs</span>
          </div>
          <img className="hide-mobile" src={imgNoel}/>
        </div>
          <div className="pn_text_container">
            <h2>Ai-je droit <br/> à la <span>prime de noël</span> ?</h2>
            <img className="hide-desktop" src={imgNoel} />
            <h4>La réponse en quelques clics</h4>
            <div>Quelques questions et vous saurez si <br/>
            vous pouvez bénéficier de cette aide</div>
            <button className="pn_button" id="start_simulation" onClick={(e)=>(props.setStep(1))}>C'est parti</button>
          </div>
          
          <div className="clear clearfix"></div>
          <div className="site-address row">
                <img src={logoBlanc} alt="logo aide-sociale.fr"/>
          </div>
        </div>;
}